import { ProductData } from "../model/types/productData";

export const calcAnnualSavings = (yearlyProduct: ProductData, monthlyAnalog: ProductData): number => {
  return Number(monthlyAnalog.price) * 12 - Number(yearlyProduct.price);
};
